import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { SocialProofPopup } from './components/SocialProofPopup';
import { HeroSection } from './components/HeroSection';
import { SalesLetter } from './components/SalesLetter';
import { BenefitsTags } from './components/BenefitsTags';
import { BonusesSection } from './components/BonusesSection';
import { MercadoPagoBadge } from './components/MercadoPagoBadge';
import { CheckoutSection } from './components/CheckoutSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
const META_PIXEL_ID = '1927478928649366';
// Flag global fuera de React — sobrevive StrictMode double mount
let pixelInitialized = false;
export function App() {
  useEffect(() => {
    if (pixelInitialized) return;
    pixelInitialized = true;
    // Crear fbq manualmente
    const n: any = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    window.fbq = n;
    window._fbq = n;
    // Cargar script de Facebook
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Init + PageView (una sola vez)
    n('init', META_PIXEL_ID);
    n('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-brand-black text-brand-text font-body antialiased pt-10" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <SocialProofPopup data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <SalesLetter data-id="element-5" />
        <BenefitsTags data-id="element-6" />
        <BonusesSection data-id="element-7" />
        <MercadoPagoBadge data-id="element-8" />
        <CheckoutSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <FAQSection data-id="element-12" />
      </main>
    </div>;
}